import { VegasStepper } from 'components/VegasConference';

const Stepper = ({ currentStep, steps }) => {
  return <VegasStepper currentStep={currentStep} steps={steps} />;
};

export default Stepper;
